/**
 * SÓ RASCUNHO SE EXCLUI (10/10/2026).
 *
 * O menu da linha já oferecia "Excluir" só em Rascunho, mas o Excluir em lote aceitava Aberta e Cancelada. No servidor,
 * excluir apaga a fatura E os registros fiscais dela: uma fatura aprovada, com NF autorizada e boleto vivo no banco,
 * sumia do HUB enquanto a nota e o boleto continuavam lá fora. Fatura aprovada se cancela, não se apaga.
 *
 * Uma regra só, usada pela linha e pelo lote.
 */
export function podeExcluirFatura(inv: { status?: string | null } | null | undefined): boolean {
  return inv?.status === 'Rascunho';
}
